import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useAnalyticsData } from "modules/customerTickets/hooks/useAnalyticsData";
import React, { FC } from "react";
import ToolbarItem from "shared/components/DraftEditor/components/ToolbarItem";
import { InfoOutlinedIcon } from "shared/theme/icons/InfoOutlinedIcon";
import { StyledSpinnerWrapper } from "../../styled";
import ComparingSection from "./components/ComparingSection";
import { StyledContainer } from "./styled";

const SupportQueriesByCategory: FC = () => {
  const { isLoading } = useAnalyticsData();

  return (
    <StyledContainer>
      {!isLoading && (
        <Stack spacing="0.5rem">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="heading6">Inquiries by category</Typography>
            <ToolbarItem
              Icon={<InfoOutlinedIcon />}
              isTooltip
              tooltipTitle={
                <Typography variant="body1">
                  <strong>What it does:</strong> Lists the number of support
                  queries by category compared to the previous period.
                  <br />
                  <br />
                  <strong>How it works:</strong> Calculates the number of
                  categories selected by the user on their inquiry.
                </Typography>
              }
            />
          </Box>
          <ComparingSection />
        </Stack>
      )}
      {isLoading && (
        <StyledSpinnerWrapper>
          <CircularProgress />
        </StyledSpinnerWrapper>
      )}
    </StyledContainer>
  );
};

export default SupportQueriesByCategory;
